import { useState } from "react";
import { Plus } from "lucide-react";
import { PageHeader } from "../../../components/AppLayout";
import { Button } from "../../../components/shared/Button";
import { PlansShowcase } from "../../../components/shared/PlansShowcase";
import { CreateTierModal } from "../../../components/admin/CreateTierModal";

export function AdminPlans() {
  const [creating, setCreating] = useState(false);
  // Bumping this re-mounts the showcase so it refetches the catalog
  // after a new tier is created.
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <>
      <PageHeader
        title="Planes"
        subtitle="Edita precios, cuotas y features. Cambiar el precio crea un nuevo Stripe Price y notifica a los suscriptores activos."
        action={
          <Button variant="primary" onClick={() => setCreating(true)}>
            <span className="inline-flex items-center gap-1.5">
              <Plus className="w-4 h-4" />
              Crear plan
            </span>
          </Button>
        }
      />
      <PlansShowcase key={reloadKey} editable />
      {creating && (
        <CreateTierModal
          onClose={() => setCreating(false)}
          onSaved={() => {
            setCreating(false);
            setReloadKey((k) => k + 1);
          }}
        />
      )}
    </>
  );
}
